// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimDetailsResponseModel {
    static getAttributeTypeMap() {
        return ClaimDetailsResponseModel.attributeTypeMap;
    }
}
ClaimDetailsResponseModel.discriminator = undefined;
ClaimDetailsResponseModel.additionalProperties = false;
ClaimDetailsResponseModel.attributeTypeMap = [
    {
        "name": "paymentMethodDetail",
        "baseName": "paymentMethodDetail",
        "type": "LookupModel"
    },
    {
        "name": "claimStatusDetail",
        "baseName": "claimStatusDetail",
        "type": "LookupModel"
    },
];
//# sourceMappingURL=claimDetailsResponseModel.js.map